import { useState } from 'react'
import { Container, Tabs, Tab } from 'react-bootstrap'
import ChartOfAccountsTree from '../../components/Accounting/ChartOfAccountsTree'
import ClientCustomization from '../../components/Accounting/ClientCustomization'
import XMLProcessing from '../../components/Accounting/XMLProcessing'
import SATCatalogs from '../../components/Accounting/SATCatalogs'
import AccountMapping from '../../components/Accounting/AccountMapping'
import DeductibilityRules from '../../components/Accounting/DeductibilityRules'
import TaxCalculationDashboard from '../../components/Accounting/TaxCalculationDashboard'
import FiscalPeriodsList from '../../components/Accounting/FiscalPeriodsList'
import TransactionsList from '../../components/Accounting/TransactionsList'
import './Accounting.css'

const Accounting = () => {
  const [activeTab, setActiveTab] = useState('chart')

  return (
    <Container fluid className="accounting-page">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Módulo de Contabilidad</h1>
      </div>

      <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
        <Tab eventKey="chart" title="Plan de Cuentas">
          <ChartOfAccountsTree />
        </Tab>
        <Tab eventKey="customization" title="Personalización por Cliente">
          <ClientCustomization />
        </Tab>
        <Tab eventKey="xml" title="Procesamiento XML">
          <XMLProcessing />
        </Tab>
        <Tab eventKey="transactions" title="Transacciones Contables">
          <TransactionsList />
        </Tab>
        <Tab eventKey="fiscal-periods" title="Períodos Fiscales">
          <FiscalPeriodsList />
        </Tab>
        <Tab eventKey="tax-calculation" title="Cálculo de Impuestos">
          <TaxCalculationDashboard />
        </Tab>
        <Tab eventKey="sat" title="Catálogos SAT">
          <SATCatalogs />
        </Tab>
        <Tab eventKey="mapping" title="Mapeo de Cuentas">
          <AccountMapping />
        </Tab>
        <Tab eventKey="deductibility" title="Reglas de Deducibilidad">
          <DeductibilityRules />
        </Tab>
      </Tabs>
    </Container>
  )
}

export default Accounting
